const SUBDOMAINS_TO_LOCALIZE = new Set(["", "www", "legal", "about"]);

export const localizeUrlDomain = (url: string, isChina: boolean): string => {
  if (!isChina) return url;

  const domainPrefix = url
    .split("polestar.com")[0]
    .replace(/^https?:\/\//, "")
    .replaceAll(".", "");

  if (SUBDOMAINS_TO_LOCALIZE.has(domainPrefix)) {
    return url.replace(/polestar\.com/, "polestar.cn");
  }

  return url;
};
